module.exports = __webpack_public_path__ + "img/homepage_guide.svg";